import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store/index';
import './registerServiceWorker';
import VeeValidate from 'vee-validate';
import Meta from 'vue-meta';
import VueResource from "vue-resource";

Vue.config.productionTip = false;

Vue.use(VueResource);
Vue.use(Meta);
Vue.use(VeeValidate, {
  events: 'change|blur|input',
});
Vue.http.interceptor.before = function(request) {
  if (localStorage.getItem('token') === null) {
    request.headers.delete('Authorization');
  }
};

router.beforeEach( async (to, from, next) => {
  if (localStorage.getItem('token') !== null) {
    store.commit('user/CHANGE_AUTH', true);
    Vue.http.headers.common['Authorization'] = `Token ${localStorage.getItem('token')}`;
    if (store.state.user.email === '') {
      store.commit('user/CHANGE_EMAIL', localStorage.getItem('email'));
    }
  }
  else {
    store.commit('user/CHANGE_AUTH', false);
    store.commit('user/CHANGE_EMAIL', '');
  }
  if (store.state.user.auth) {
    if (to.meta.loginPage) {
      next({name: 'menu'});
    }
    else {
      next();
    }
  }
  else {
    if (to.meta.loginPage) {
      next();
    }
    else {
      next({name: 'login'});
    }
  }
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
